import type { Topic } from '@/@types/topic'
import { notFound, redirect } from '@tanstack/react-router'
import { isEmpty } from 'lodash-es'
import { getCurrentRedirectURL } from './redirectURL'
import storage from './Storage'
import queryClient from './queryClient'

export function clearUserSession() {
	storage.auth.token = null
	storage.auth.refreshToken = null
	storage.auth.deviceId = null
	queryClient.clear()
}

// redirect to login page if not logged in
export function navigateToLoginPage() {
	clearUserSession()
	const url = new URL(window.location.href)
	url.pathname = '/login'
	url.searchParams.set('redirectURL', getCurrentRedirectURL())
	window.location.href = url.toString()
}

export function assertTopicRoute(topic: Topic, tab?: string) {
	if (isEmpty(topic.tabs)) {
		throw notFound()
	}

	if (!topic.tabs.find((item) => item.type === tab)) {
		throw redirect({
			to: '/topic/$id/$tab',
			params: {
				id: topic.id,
				tab: topic.tabs[0].type,
			},
			replace: true,
		})
	}
}
